module.exports = __webpack_public_path__ + "img/api-product-thumbnail-tc.5e68cf08.jpg";